export default function preSurveyJsonEn() {
  const result = [
    {
      name: "survey-page-1",
      elements: [
        {
          type: "html",
          name: "instruction",
          html: `<p><b>Please answer the questions below.</b><br>कृपया नीचे दिए गए प्रश्नों का उत्तर दें।</p>`
        },
        {
          type: "text",
          name: "age",
          title: "What is your age? / आपकी आयु क्या है?",
          inputType: "number",
          min: 18,
          max: 100,
          isRequired: true,
          minErrorText: "You must be at least 18 years old. / आपकी आयु कम से कम 18 वर्ष होनी चाहिए।",
          maxErrorText: "Please enter a valid age. / कृपया एक मान्य आयु दर्ज करें।"
        },
        {
          type: "radiogroup",
          name: "gender",
          title: "What is your gender? / आपका लिंग क्या है?",
          isRequired: true,
          choices: [
            { value: "male", text: "Male / पुरुष" },
            { value: "female", text: "Female / महिला" },
            { value: "other", text: "Other / अन्य" }
          ]
        },
        {
          type: "radiogroup",
          name: "religion",
          title: "What is your religion? / आपका धर्म क्या है?",
          isRequired: true,
          choices: [
            { value: "hindu", text: "Hindu / हिन्दू" },
            { value: "muslim", text: "Muslim / मुस्लिम" },
            { value: "christian", text: "Christian / ईसाई" },
            { value: "other", text: "Other / अन्य" }
          ]
        },
        {
          type: "text",
          name: "zipcode",
          title: "What is your PIN code? / आपका पिन कोड क्या है?",
          isRequired: true,
          validators: [
            {
              type: "regex",
              regex: "^\\d{6}$",
              text: "Please enter a valid 6-digit PIN code. / कृपया एक मान्य 6-अंकीय पिन कोड दर्ज करें।"
            }
          ]
        }
      ]
    },
    {
      name: "survey-page-2",
      elements: [
        {
          type: "radiogroup",
          name: "caste",
          title: "Which social category do you belong to? / आप किस सामाजिक वर्ग से संबंधित हैं?",
          isRequired: true,
          choices: [
            { value: "sc", text: "SC (Scheduled Caste) / अनुसूचित जाति" },
            { value: "st", text: "ST (Scheduled Tribe) / अनुसूचित जनजाति" },
            { value: "obc", text: "OBC (Other Backward Class) / अन्य पिछड़ा वर्ग" },
            { value: "general", text: "General / सामान्य" },
            { value: "other", text: "Other / अन्य" }
          ]
        },
        {
          type: "radiogroup",
          name: "monthly_income",
          title: "What is your monthly household income? / आपके परिवार की मासिक आय क्या है?",
          isRequired: true,
          choices: [
            { value: "less_than_20k", text: "Less than ₹20,000 / ₹20,000 से कम" },
            { value: "20k_to_50k", text: "₹20,000 to ₹49,999 / ₹20,000 से ₹49,999" },
            { value: "50k_to_1lakh", text: "₹50,000 to ₹99,999 / ₹50,000 से ₹99,999" },
            { value: "1lakh_or_more", text: "₹1 lakh or more / ₹1 लाख या अधिक" }
          ]
        },
        {
          type: "radiogroup",
          name: "education",
          title: "What is your highest level of education? / आपकी उच्चतम शिक्षा का स्तर क्या है?",
          isRequired: true,
          choices: [
            { value: "upto_class_8", text: "Up to class 8 / कक्षा 8 तक" },
            { value: "class_9_10", text: "Class 9-10 / कक्षा 9-10" },
            { value: "class_11_12_diploma", text: "Class 11-12 or diploma / कक्षा 11-12 या डिप्लोमा" },
            { value: "graduate_or_above", text: "Graduate or above / स्नातक या उससे ऊपर" }
          ]
        },
        {
          type: "text",
          name: "occupation",
          title: "What is your occupation? / आपका व्यवसाय क्या है?",
          isRequired: true,
          placeHolder: "Enter your occupation / अपना व्यवसाय दर्ज करें"
        }
      ]
    },
    {
      name: "survey-page-3",
      elements: [
        {
          type: "radiogroup",
          name: "lok_sabha_2024_vote",
          title: "In the last Lok Sabha election (in 2024), which option best describes you? / पिछले लोकसभा चुनाव (2024) में, कौन सा विकल्प आपको सबसे अच्छी तरह से वर्णित करता है?",
          isRequired: true,
          choices: [
            { value: "ruling_party", text: "I voted for the ruling party / मैंने सत्ताधारी पार्टी को वोट दिया" },
            { value: "main_opposition", text: "I voted for the main opposition party / मैंने मुख्य विपक्षी पार्टी को वोट दिया" },
            { value: "another_party", text: "I voted for another party / मैंने किसी अन्य पार्टी को वोट दिया" },
            { value: "did_not_vote", text: "I did not vote / मैंने वोट नहीं दिया" },
            { value: "not_eligible", text: "I was not eligible / मैं योग्य नहीं था" },
            { value: "prefer_not_to_say", text: "Prefer not to say / बताना पसंद नहीं" }
          ]
        }
      ]
    }
  ];

  const preSurveyForm = {
    progressBarType: "pages",
    showProgressBar: "top",
    logoPosition: "right",
    pages: result
  };

  return JSON.stringify(preSurveyForm);
}
